// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AiTuning_tabs___09Q3","contenter":"AiTuning_contenter__7Jysi","table":"AiTuning_table__1CyBV"};